var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Social Media/Linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars/Footer/Desktop-(HKG)",
    transform: "translate(-1150.000000, -24.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-Media",
    transform: "translate(1139.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Social-Media/Linkedin",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7694779,8.92642354 L12.2184739,6.06014075 L9.39919679,6.06014075 L9.39919679,4.19705694 C9.39919679,3.40882917 9.8064257,2.64107486 11.0594378,2.64107486 L12.3333333,2.64107486 L12.3333333,0.204734485 C12.3333333,0.204734485 11.184739,0 10.0779116,0 C7.75983936,0 6.2562249,1.38195777 6.2562249,3.86948177 L6.2562249,6.06014075 L3.66666667,6.06014075 L3.66666667,8.92642354 L6.2562249,8.92642354 L6.2562249,15.8771593 C6.76787149,15.9590531 7.30040161,16 7.83293173,16 C8.36546185,16 8.89799197,15.9590531 9.40963855,15.8771593 L9.40963855,8.92642354 L11.7694779,8.92642354 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.43de8cc0e8d53a2ae716579e347e7437.svg";
export { ForwardRef as ReactComponent };